import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ModalComponent } from 'src/app/modules/components/modal/modal.component';
import { AfericaoServicoInicialService } from '../../afericao-servico-Inicial/afericao-servico-inicial.service';
import { DocumentoComprovacaoService } from 'src/app/modules/services/documento-comprovacao/documento-comprovacao.service';
import * as moment from 'moment';
import { MatTooltip } from '@angular/material/tooltip';
import { AfericaoRelatorioService } from 'src/app/modules/services/afericao-relatorio/afericao-relatorio.service';
import { AfericaoOperacionalService } from 'src/app/modules/services/afericao-operacional/afericao-operacional.service';
interface AnalyzeItem {
  id: number;
  label: string;
  description: string;
  responsibleId: number | null;
  dueDate: Date | null;
  selected: boolean;
}

interface ResponsibleOption {
  id: number;
  name: string;
}

@Component({
  selector: 'app-analyze-detail',
  templateUrl: './analyze-detail.component.html',
  styleUrls: ['./analyze-detail.component.scss']
})
export class AnalyzeDetailComponent implements OnInit {
  @ViewChild('myButtonTooltip') tooltip!: MatTooltip;
  tooltipActive = false;
  form!: FormGroup;
  protocolos: string[] = [];
  private contador = 1;
  protocolDataMap = new Map<string, any>();
  private savedData: { [protocolo: string]: AnalyzeItem[] } = {};
  optionProtocolSelected: string = '';
  responsibleOptions: ResponsibleOption[] = [];
    responsibleOptionsSupervisora: ResponsibleOption[] = [];
  rawItems: AnalyzeItem[] = [];
  analises: any;
  idEntidade: any;
  idAfericao: any;
  oldProtocol: any;
  analisesAfericao: any = [];
  transicaoNome: any;
  idDocumentoComprovacao: any;
  tooltipText = '';
  tooltipHtml = '';
  arrayProtocolos: any = [];
  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AnalyzeDetailComponent>,
    private afericaoServicoInicialService: AfericaoServicoInicialService,
    private documentoComprovacaoService: DocumentoComprovacaoService,
    private afericaoRelatorioService: AfericaoRelatorioService,
    private afericaoOperacionalService: AfericaoOperacionalService,
    @Inject(MAT_DIALOG_DATA) public data: { protocoloInicial?: string, idEntidade?: string, transicaoNome?: string, idAfericao?: string, from?: string},
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      protocolo: [this.data?.protocoloInicial || ''],
      items: this.fb.array([])
    });
    this.idEntidade = this.data?.idEntidade;
    this.idAfericao = this.data?.idAfericao;
    this.transicaoNome = this.data?.transicaoNome;
    if (this.data?.protocoloInicial) {
      this.protocolos.push(this.data.protocoloInicial);
      this.savedData[this.data.protocoloInicial] = this.cloneRawItems();
    }
    if (this.idEntidade) {
      this.getSelectOptions();
    }
    if (this.idAfericao) {
      this.getProtocolos();
    }
    this.getAnalises();


  }
  getAnalises() {
    if(this.data.from == 'afericao-operacional'){
      this.afericaoOperacionalService.getTipoAnalises().subscribe((results: any) => {
      this.analises = results.content;
      this.buildRawItems(results.content);
      this.loadItemsIntoForm(this.rawItems);
    })
    }else{
      this.afericaoServicoInicialService.getTipoAnalises().subscribe((results: any) => {
      this.analises = results.content;
      this.buildRawItems(results.content);
      this.loadItemsIntoForm(this.rawItems);
    })
    }
  
  }
  getProtocolos() {
    if(!this.data.from){
    this.afericaoServicoInicialService.getProtocolos(this.idAfericao).subscribe((results: any) => {
      this.arrayProtocolos = results;
      const protocoloInicial = results[0]?.documentoComprovacao?.protocoloContrato?.numeroProtocolo;
      this.idDocumentoComprovacao = results[0]?.documentoComprovacao?.id
      if (protocoloInicial) {
        this.protocolos.push(protocoloInicial);
        this.form.get('protocolo')?.setValue(protocoloInicial);
        this.oldProtocol = protocoloInicial;
        this.createTooltip()
        this.loadItemsIntoForm(this.rawItems);
        this.contador++;
      }
    })
    }else if(this.data.from == 'afericao-relatorio'){
      this.afericaoRelatorioService.getProtocolos(this.idAfericao).subscribe((results: any) => {
      this.arrayProtocolos = results;
      const protocoloInicial = results[0]?.documentoComprovacao?.protocoloContrato?.numeroProtocolo;
      this.idDocumentoComprovacao = results[0]?.documentoComprovacao?.id
      if (protocoloInicial) {
        this.protocolos.push(protocoloInicial);
        this.form.get('protocolo')?.setValue(protocoloInicial);
        this.oldProtocol = protocoloInicial;
        this.createTooltip()
        this.loadItemsIntoForm(this.rawItems);
        this.contador++;
      }
    })
    }else if(this.data.from == 'afericao-operacional'){
  this.afericaoOperacionalService.getProtocolos(this.idAfericao).subscribe((results: any) => {
      this.arrayProtocolos = results;
      const protocoloInicial = results[0]?.documentoComprovacao?.protocoloContrato?.numeroProtocolo;
      this.idDocumentoComprovacao = results[0]?.documentoComprovacao?.id
      if (protocoloInicial) {
        this.protocolos.push(protocoloInicial);
        this.form.get('protocolo')?.setValue(protocoloInicial);
        this.oldProtocol = protocoloInicial;
        this.createTooltip()
        this.loadItemsIntoForm(this.rawItems);
        this.contador++;
      }
    })
    }
   
  }
  getSelectOptions() {
    this.documentoComprovacaoService.getUsuariosAssinantes(this.idEntidade,'', '').subscribe((results: any) => {
      this.buildResponsibleOptions(results.content);
    })
    this.documentoComprovacaoService.getUsuariosAssinantes(this.idEntidade).subscribe((results: any) => {
      this.buildResponsibleOptionsSupervisora(results.content);
    })
  }
buildRawItems(analises: any[]) {
  this.rawItems = analises.map(analise => {
    return {
      id: analise.id,
      label: analise.nome,
      description: '',
      responsibleId: null,
      dueDate: null,
      selected: false
    };
  });
}
  buildResponsibleOptions(users: any) {
    this.responsibleOptions = users.map((item: any) => {
      const newItem = {
        id: item.user.id,
        name: item.user.nome
      }
      return item = newItem;
    });
  }
  buildResponsibleOptionsSupervisora(users: any) {
    this.responsibleOptionsSupervisora = users.map((item: any) => {
      const newItem = {
        id: item.user.id,
        name: item.user.nome
      }
      return item = newItem;
    });
  }

  private cloneRawItems(): AnalyzeItem[] {
    return this.rawItems.map(item => ({
      id: item.id,
      label: item.label,
      description: item.description,
      responsibleId: item.responsibleId,
      dueDate: item.dueDate,
      selected: item.selected
    }));
  }
  get itemsFormArray(): FormArray {
    return this.form.get('items') as FormArray;
  }


  onProtocoloChange(value: string): void {
    // Salva o protocolo anterior
    if (this.oldProtocol) {
      this.saveInfoProtocol();
    }

    // Se gerar novo protocolo
    if (value === 'gerar') {
      let novoProtocolo = `Gerando novo protocolo - ${this.formatarNumero(this.contador)}`;
      while (this.protocolos.includes(novoProtocolo)) {
        this.contador++;
        novoProtocolo = `Gerando novo protocolo - ${this.formatarNumero(this.contador)}`;
      }

      this.protocolos.unshift(novoProtocolo);
      this.form.get('protocolo')?.setValue(novoProtocolo);
      this.oldProtocol = novoProtocolo;

      this.loadItemsIntoForm(this.rawItems);
      this.contador++;
      return;
    }

    // Protocolo existente
    this.form.get('protocolo')?.setValue(value);
    this.oldProtocol = value;

    const savedItems = this.protocolDataMap.get(value);
    const itemsToLoad = savedItems
      ? savedItems.items
      : this.analisesAfericao.find(([key]: any) => key === value)?.[1]?.items || [];

    this.loadItemsIntoForm(itemsToLoad);

    // Habilita ou desabilita com base no protocolo
    if (!value) {
      this.itemsFormArray.disable();
    } else {
      // Habilita os campos individualmente com base no selected
      this.itemsFormArray.controls.forEach(group => {
        const selected = group.get('selected')?.value;
        ['description', 'responsibleId', 'dueDate'].forEach(field => {
          const ctrl = group.get(field);
          selected ? ctrl?.enable() : ctrl?.disable();
        });
      });
    }
  }
  createTooltip() {
    const protocolo = this.arrayProtocolos.find((item: any) => item.documentoComprovacao.protocoloContrato.numeroProtocolo == this.form.get('protocolo')?.value);
    if (protocolo) {
      const revisao = protocolo.documentoComprovacao.protocoloContrato.revisao;
      const autor = revisao.autor;
      const data = moment(revisao.data)
        .locale('pt-br')
        .format('DD/MM/YYYY - HH:mm');
      const status = protocolo.documentoComprovacao.protocoloContrato.statusOrigem;
      
      this.tooltipText = `${autor}          ${data}hs                 Status: ${status}`;
    } else {
      this.tooltipText = ``;
    }

  }
  loadItemsIntoForm(items: any[]) {
    const formArray = new FormArray<FormGroup>([]);

    items.forEach(item => {
      const group = this.fb.group({
        id: [item.id],
        label: [item.label],
        selected: [item.selected],
        description: [{ value: item.description, disabled: !item.selected }],
        responsibleId: [{ value: item.responsibleId, disabled: !item.selected }],
        dueDate: [{ value: item.dueDate, disabled: !item.selected }]
      }) as FormGroup;

      formArray.push(group);
    });

    this.form.setControl('items', formArray);
    this.listenToSelectedChanges(formArray);

    // 👇 Aplica regra de habilitação baseada no 'selected' para o carregamento inicial
    formArray.controls.forEach(group => {
      const selected = group.get('selected')?.value;
      ['description', 'responsibleId', 'dueDate'].forEach(field => {
        const ctrl = group.get(field);
        selected ? ctrl?.enable() : ctrl?.disable();
      });
    });
  }

  listenToSelectedChanges(itemsArray: FormArray) {
    itemsArray.controls.forEach((group: AbstractControl) => {
      const selectedCtrl = group.get('selected');
      selectedCtrl?.valueChanges.subscribe((selected: boolean) => {
        ['description', 'responsibleId', 'dueDate'].forEach(field => {
          const ctrl = group.get(field);
          selected ? ctrl?.enable() : ctrl?.disable();
        });
      });
    });
  }
  private formatarNumero(numero: number): string {
    return numero.toString().padStart(2, '0');
  }

  save(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.saveInfoProtocol();
    const data = {
      idDocumentoComprovacao: this.idDocumentoComprovacao,
      data: this.protocolDataMap
    }
    this.dialogRef.close(data);
  }

  saveInfoProtocol() {
    const formValue = this.form.value;
    const protocolo = formValue.protocolo;

    if (this.oldProtocol) {
      this.protocolDataMap.set(this.oldProtocol, formValue);
    } else {
      this.protocolDataMap.set(protocolo, formValue);
    }
    this.createTooltip();
    return
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  calcFinalDate(event: any, controlName: string, index?: number): void {
    const dataSelecionada: Date = event.value;
  }
}
